const promo = {
  // ongoing: 'Ongoing Campaigns',
  ongoing: 'Ongoing',
  games:'Games',
  empty: 'Ongoing Campaigns',
  title: 'Title',
  type: 'Type',
  past:'Past',
  add: 'Add Campaign',
  campaigns: 'Campaigns',
  monitoring: {
    views: 'Viewship rate',
    clicks: 'Clickthrough rate',
  },
  views: 'Views',
  card: {
    campaign: {
      title: 'Campaign',
      content: 'Advertise campaigns for individual, group, or a company here.',
      btn: 'View Campaign',
    },
    credit: {
      title: 'Credit',
      content: 'Buy credits which which will be used for campaign here.',
      btn: 'View Credit'
    },
    contact: {
      title: 'Contact',
      content: 'Save or import your lists of contacts for quick and easy access here.',
      btn: 'View Contact'
    },
  },
  create: {
    info: 'Campaign Information',
    audience: 'Target Audience',
    budget: 'Budget',
    upload: 'File upload',
  },
  modal: {
    title: 'Enter PIN',
    confirm: 'Confirm'
  },
  form: {
    audience: 'Target Audience',
    reach: 'Potential Reach',
    impression: 'Impressions',
    budget: 'Cost & Budget',
    available: 'Available Credit',
    campaign: 'Campaign Credit',
    balance: 'Balance',
    views: 'Views',
    1: {
      title: {
        label: 'Campaign title',
        placeholder: 'Enter campaign title'
      },
      url: {
        label: 'Callback URL',
        placeholder: 'www.mywebsite.com'
      },
      message: {
        label: 'Enter Call To Action Message',
        placeholder: 'Call To Action Message'
      },
      type: 'Campaign type',
      description: {
        label: 'Describe your advertisement',
        placeholder: 'Enter Call To Action Message'
      }
    }
  },
  schedules: {
    title: 'Create schedule',
    form: {
      start: 'Start time',
      end: 'End time',
      days: 'Schedule days',
    }
  }
};

export default promo;